import React from 'react';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';
import { CloudImage } from '@components/CloudImage';
import { Box } from '@components/Box';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';
import {
  HeroTextPairing,
  HeroVideoContainer,
  HeroVideoWrapper,
  HeroOverlay,
  HeroCloudImage,
  RegistryHeroTextColumn,
  StyledSection,
  BlogCenterTextPairing,
} from '@sections/honeymoon-registry/RegistryHeroSection/RegistryHeroSection.styles';
import { registryPageData } from '@data-ts/pages/honeymoon-registry';
import ReactHtmlParser from 'react-html-parser';
import { styled } from '@components/styledComponents';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { VimeoVideo } from '@components/VimeoVideo';

const registryHeroData = registryPageData.hero;
const HERO_VIDEO_URL = 'https://player.vimeo.com/video/652651051?badge=0&autopause=0&player_id=0&app_id=58479/embed';

const DisplayAboveMobile = styled(Box)`
  display: block;
  height: 100%;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

const DisplayOnMobile = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const RegistryHeroSection = () => {
  return (
    <StyledSection as="section" id="Registry_Hero">
      <HeroVideoContainer>
        <HeroVideoWrapper>
          <HeroOverlay />
          <DisplayOnMobile>
            <HeroCloudImage src="honeymoon-fund/mobile-hero.jpg" isEagerLoading width="auto" height="100%" optimization="aggressive" />
          </DisplayOnMobile>
          <DisplayAboveMobile>
            <VimeoVideo
              posterUrl="honeymoon-fund/static-hero.jpg"
              embedUrl={HERO_VIDEO_URL}
              title="Honeymoon Hero"
              autoPlay
              background
              controls={false}
              autoPause={false}
              muted
              loop
              cover
              posterOptimization="aggressive"
            />
          </DisplayAboveMobile>
        </HeroVideoWrapper>
      </HeroVideoContainer>
      <RegistryHeroTextColumn verticalAlign="center">
        <Columns.Column width={6} tablet={8} desktop={6}>
          <Flex flexDirection={'column'} alignItems={['left', 'left']}>
            <HeroTextPairing
              title={ReactHtmlParser(registryHeroData.title)}
              titleVariant="hed72Hero"
              titleColor="mono7"
              titleTagName="h1"
              alignment={'left'}
            />

            <Flex flexDirection={'row'} alignItems={'left'} marginBottom={[4, 6]}>
              <CloudImage src="honeymoon-fund/check-icon.svg" width={'22px'} optimization="aggressive" />
              <BlogCenterTextPairing
                alignment="left"
                title={registryHeroData.bullet1}
                titleVariant="sectionEyeBrow24"
                titleColor="humana1Light"
                marginLeft={[6, 6]}
              />
            </Flex>
            <Flex flexDirection={'row'} alignItems={'left'} marginBottom={[4, 6]}>
              <CloudImage src="honeymoon-fund/check-icon.svg" width={'22px'} optimization="aggressive" />
              <BlogCenterTextPairing
                alignment="left"
                title={registryHeroData.bullet2}
                titleVariant="sectionEyeBrow24"
                titleColor="humana1Light"
                marginLeft={[6, 6]}
              />
            </Flex>
            <Flex flexDirection={'row'} alignItems={'left'} marginBottom={[6, 8]}>
              <CloudImage src="honeymoon-fund/check-icon.svg" width={'22px'} optimization="aggressive" />
              <BlogCenterTextPairing
                alignment="left"
                title={registryHeroData.bullet3}
                titleVariant="sectionEyeBrow24"
                titleColor="humana1Light"
                marginLeft={[6, 6]}
              />
            </Flex>
            <Box style={{ textAlign: 'left' }}>
              <GetStartedButton id="honeymoonRegistryHeroGetStartedBtn" page={'registry'} variant="secondary">
                {registryPageData.getStarted}
              </GetStartedButton>
            </Box>
          </Flex>
        </Columns.Column>
      </RegistryHeroTextColumn>
    </StyledSection>
  );
};
